module.exports = __webpack_public_path__ + "static/img/5059_phase_function_Paper_Points.d493be2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5059_phase_function_Paper_Points.png
// module id = s5FB
// module chunks = 0